import {NoEntryFillIcon} from '@primer/octicons-react'

import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'

export function NotReadyStatusIcon({status}: {status: EffectiveEntryStatusType}) {
  if (
    status !== EffectiveEntryStatus.NotReady &&
    status !== EffectiveEntryStatus.MergeConflicts &&
    status !== EffectiveEntryStatus.NeedsRebase
  ) {
    return null
  }

  return <NoEntryFillIcon size={12} className="color-fg-attention" />
}
